import { ChangeDetectionStrategy, Component, OnChanges, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'mode-datasource-access-level',
  templateUrl: './datasource-access-level.component.html',
  styleUrls: ['./datasource-access-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasourceAccessLevelComponent implements OnChanges {
  @Input() accessLevel: 'View' | 'Query' | 'None' | null = null;
  iconType = '';
  description = '';

  ngOnChanges(changes: SimpleChanges): void {
    const { accessLevel } = changes;
    if (accessLevel.currentValue) {
      switch (accessLevel.currentValue) {
        case 'View':
          this.iconType = 'icon-building-view';
          this.description = 'All Members can View';
          break;
        case 'Query':
          this.iconType = 'icon-building-edit';
          this.description = 'All Members can Query';
          break;
        default:
          this.iconType = 'icon-lock';
          this.description = 'Restricted';
          break;
      }
    }
  }
}
